import React from 'react';

import Link from '../Link/Link';
import { Note } from '../Note/Note';

import { DevPreviewBanner } from './DevPreviewBanner';
import { DocumentationTypo } from './DocumentationTypo';

const { Paragraph, H1, CodeBlockInline, DocPage } = DocumentationTypo;

const appmetricaLink = 'https://appmetrica.yandex.ru';
const quickstartLink = 'https://appmetrica.yandex.ru/docs/quick-start/concepts/quick-start.html';

const displayDevPreviewWarnings = __appConfig.app.displayDevPreviewWarnings;

export const AppMetricaDocPage: React.FC = () => {
    return (
        <DocPage>
            <H1>AppMetrica</H1>
            {displayDevPreviewWarnings && <DevPreviewBanner />}
            <Paragraph>
                AppMetrica позволяет разработчику навыка собирать статистику о&nbsp;том, как люди им&nbsp;пользуются:
                например аудиторные показатели, количество и&nbsp;длину сессий. Собранные данные можно просматривать
                в&nbsp;веб-интерфейсе AppMetrica.
            </Paragraph>
            <Paragraph>
                Чтобы начать отправлять события, <Link to={quickstartLink}>создайте</Link> приложение на&nbsp;
                <Link to={appmetricaLink}>appmetrica.yandex.ru</Link>, скопируйте значение поля{' '}
                <CodeBlockInline>API key (для использования в&nbsp;SDK)</CodeBlockInline> в&nbsp;поле{' '}
                <CodeBlockInline>API-ключ</CodeBlockInline> настроек навыка, сохраните и&nbsp;опубликуйте черновик.
            </Paragraph>
            <Note
                type="info"
                inlineContent={<>Данные могут поставляться с&nbsp;задержкой до&nbsp;нескольких часов.</>}
            />
        </DocPage>
    );
};
